import { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useEsri } from '../../esriHooks'

import { getMap, getView, getSelectedParcels } from '../selectors'
import { setSelectedParcels } from '../actions'

import { PARCEL_SERVICE_URL } from '../constants'

const esriReqs = ['esri/layers/FeatureLayer']

const ParcelLayer = ({
  mapId
}) => {
  const dispatch = useDispatch()
  const [ready, { FeatureLayer }] = useEsri(esriReqs)
  const map = useSelector(getMap(mapId))
  const view = useSelector(getView(mapId))
  const selectedParcels = useSelector(getSelectedParcels)
  const [highlight, setHighlight] = useState(null)
  const [layer, setLayer] = useState(null)
  
  useEffect(() => {
    if (ready && map) {
      const newLayer = new FeatureLayer({
        url: PARCEL_SERVICE_URL,
        outFields: ['OwnerName', 'LegalDescr', 'PIN', 'OBJECTID']
      })
      map.add(newLayer)
      setLayer(newLayer)
    }
  }, [ready, FeatureLayer, map])

  // Set on click handler for layer
  useEffect(() => {
    if (view) {
      const handler = view.on('click', (event) => {
        if (view.scale <= layer.minScale || layer.minScale === 0) { // seems backwards.. is right.
          const screenPoint = {
            x: event.x,
            y: event.y,
          }

          const point = view.toMap(screenPoint)
          layer.queryFeatures({
            geometry: point,
            spatialRelationship: 'intersects',
            returnGeometry: true,
            outSpatialReference: { wkid: 4326 },
            outFields: ['*'],
            orderByFields: ['OwnerName', 'PIN']
          }).then((result) => {
            dispatch(setSelectedParcels(result.features))
          })
        }
      })
      return handler.remove
    }
  }, [view, layer, dispatch])

  useEffect(() => {
    if (view && layer) {
      view.whenLayerView(layer).then(layerView => {
        if (highlight) highlight.remove()
        setHighlight(layerView.highlight(selectedParcels.map(f => f.attributes.OBJECTID)))
      })
    }
  }, [view, selectedParcels])

  return null
}

export default ParcelLayer
